import { Placement } from '@floating-ui/dom';

import { closestDropdownPanel } from '@shared/components/dropdown-singleton/dropdown-panel.utils';

/** What floating-ui measures the popup against, and where it goes relative to it. */
export interface PopupPositioning {
  reference: HTMLElement;
  placement: Placement;
}

/**
 * A popup anchored to a row of an open dropdown panel — a uid pill in a table cell's
 * expanded "+N more" list — must clear the panel rather than cover the list the click came
 * from. Overlapping also hides it outright: the dropdown singleton's host is mounted after
 * the popup outlets and shares their z-index, so it wins the tie and paints on top.
 */
const PANEL_ESCAPE_PLACEMENT: Placement = 'right-start';

/**
 * Sides the popup off the panel containing `anchor`, if any; `flip()` takes the other side
 * when the viewport has no room. Anywhere else the anchor and requested placement stand.
 */
export function resolvePopupPositioning(
  anchor: HTMLElement,
  placement: Placement
): PopupPositioning {
  const panel = closestDropdownPanel(anchor);
  return panel
    ? { reference: panel, placement: PANEL_ESCAPE_PLACEMENT }
    : { reference: anchor, placement };
}
